import { render, staticRenderFns } from "./PendingMoveItemExpanded.vue?vue&type=template&id=b9995308&"
import script from "./PendingMoveItemExpanded.vue?vue&type=script&lang=ts&"
export * from "./PendingMoveItemExpanded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports